<template>
    <span class="appeal-tag" :class="{'appeal-tag--other': other}"><slot/></span>
</template>

<script>
    // Метка обращения в ленте заявки (строка звонка и блок «Повторное обращение»).
    // Цвет только там, где источник отличается: other — оранжевая «ДРУГОЙ ИСТОЧНИК», остальные нейтральные серые.
    export default {
        name: "AppealTag",
        props: {
            other: {type: Boolean, default: false},
        },
    }
</script>

<style scoped>
    /* Интервал между метками даёт пробел в разметке: при переносе строки метка не получает лишнего отступа слева */
    .appeal-tag {
        display: inline-block;
        padding: 0 .4rem;
        border: 1px solid #ced4da;
        border-radius: 3px;
        color: #6c757d;
        font-size: 11px;
        font-weight: 400;
        line-height: 1.6;
        vertical-align: middle;
        white-space: nowrap;
    }
    .appeal-tag--other {
        border-color: #f4a95b;
        background: #fff3e3;
        color: #c25a00;
        font-weight: 700;
        letter-spacing: .02em;
    }
</style>
